import maplibregl from "maplibre-gl";
import polyline from "@mapbox/polyline";
import { fitBoundsConfig } from "../map-config";

function startStopMarkers(waypoints) {
  const first = waypoints.at(0)
  const last = waypoints.at(-1)

  if (first?.properties?.id === last?.properties?.id) {
    last.properties.icon = "start-stop";
    return [ last ];
  }
  first.properties.icon = "start";
  const markers = [ first ];
  if (last) {
    last.properties.icon = "stop";
    markers.push(last);
  }
  return markers;
}

export async function fetchAndPlotRouteOnMap(routestackId, map, includeStartMarker = true) {
  const lang = $('html').attr('lang') ?? 'nl';
  try {
    const resp = await fetch(`/${lang}/api/routes/${routestackId}/`);
    const res = await resp.json();
    const route = res.route;

    const nav = new maplibregl.NavigationControl({ showCompass: false });
    map.addControl(nav, 'top-left');

    map.setLayoutProperty("rcn-ways", "visibility", "none");
    map.setLayoutProperty("rcn-nodes", "icon-size", 1.1);
    map.setPaintProperty("route", "line-color", "rgb(21, 132, 200)");
    map.setPaintProperty("route-casing", "line-color", "rgb(255, 255, 255)");
    map.setPaintProperty("route-casing", "line-width", 12);
    map.setPaintProperty("route-casing", "line-opacity", 1);

    map.addSource(
      "additional-waypoints",
      {
        data: {
          type: "FeatureCollection",
          features: []
        },
        type: "geojson"
      }
    );
    map.addLayer(
      {
        id: "additional-waypoints",
        source: "additional-waypoints",
        type: "symbol",
        layout: {
          "icon-size": 1,
          "icon-anchor": "bottom",
          "icon-image": ["concat", "location-", ["get", "icon"]],
          "icon-ignore-placement": true,
          "icon-allow-overlap": true,
        },
        minzoom: 9,
      },
      "rcn-nodes"
    );

    // We will filter all waypoints that are not used by our active route. For the waypoints that are part of the route we will set a blue waypoint icon.
    map.setFilter("rcn-nodes", ["in", ["get", "id"], ["literal", route.nids.map((n) => n && n.toString())]])

    // Here we draw the blue line that represents the route.
    map.getSource("route").setData(polyline.toGeoJSON(route.plan.geometry));

    map.resize();
    map.fitBounds(route.bbox, fitBoundsConfig);

    if (includeStartMarker) {
      const markers = startStopMarkers(route.waypoints);

      map
        .getSource("start-stop")
        .setData({
          type: "FeatureCollection",
          features: markers,
        });
    }

    return res;
  } catch (err) {
    console.error('Error while fetching and plotting route', err);
    return null;
  }
}


export const buildMarkerElement = (imageSource, title = null, iconSize = 45) => {
  const markerElement = document.createElement('div');
  markerElement.style.backgroundImage = `url(${imageSource})`;
  markerElement.style.backgroundRepeat = 'no-repeat';
  markerElement.style.backgroundPosition = 'center';
  markerElement.style.width = `${iconSize}px`;
  markerElement.style.height = `${iconSize}px`;
  if (title) {
    markerElement.title = title;
  }

  return markerElement;
}

export const convertLocationsToMapData = (list) => {
  return list.map(location => {
    return {
      type: "Feature",
      geometry: location.geometry,
      properties: {
        type: "location",
        id: location._id,
        name: location.name,
        icon: location.highlight ? "doen" : "zien",
      },
    };
  });
}